import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { AppComponent } from "../app.component";

/* jQuery is present because Bootstrap-4 JS depends on it */
declare const $: any;

@Component({
  standalone: false,
  selector: "wgt-carousel",
  templateUrl: "./z-wgt-carousel.component.html",
  styleUrls: ["./z-wgt-carousel.component.css"],
})
export class wgtCarousel implements OnInit, AfterViewInit, OnDestroy {
  @Input() aWidgetParams: any;
  aCarouselLangData: any;

  @ViewChild("carousel", { static: true })
  private carouselEl!: ElementRef<HTMLDivElement>;

  private isInitialised = false;

  constructor(public app: AppComponent) {
    this.aCarouselLangData = app.langData.widgets.carousel;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    /* Angular renders the template **after** window load, so we need to
       create/activate the carousel ourselves or the data-API never runs. */
    if (typeof $ !== "undefined" && this.carouselEl) {
      $(this.carouselEl.nativeElement).carousel({
        interval: 5000, // 5-second auto-slide
        ride: "carousel", // start cycling immediately
        pause: "hover",
        wrap: true,
      });
      this.isInitialised = true;
    }
  }

  ngOnDestroy(): void {
    if (this.isInitialised && typeof $ !== "undefined") {
      $(this.carouselEl.nativeElement).carousel("dispose");
    }
  }
}
